import React from 'react'

import styled from 'styled-components'

import {
    Box,
    ButtonV2,
    IconV2,
    Loader,
    Mask,
    Typography,
} from '@/elements'

import { Color } from '@/utils'

const ConfirmModalElement = styled.div`
  max-width: 410px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  gap: 30px;
  background: ${Color.white};
  border-radius: 5px;
  box-shadow: 0px 4px 7px rgba(157, 173, 184, 0.2);
`

export const ConfirmModal = ({
  title,
  description,
  icon,
  loading,
  decline,
  confirm,
  children,
}) => (
    <Mask>
        <ConfirmModalElement>
            {/* Loader */}
            {loading && <Loader />}

            {/* Header */}
            <Box direction="column" align="center" gap="20px">
                {icon && <IconV2 name={icon} size={40} />}

                {title && (
                    <Typography variant="h5" align="center" color={Color.textMain}>
                        {title}
                    </Typography>
                )}

                <Box direction="column" justify="center" gap="12px">
                    {description && (
                        <Typography
                            variant="body1"
                            align="center"
                            color={Color.textSecondary}
                        >
                            {description}
                        </Typography>
                    )}

                    {children}
                </Box>
            </Box>

            {/* Buttons */}
            <Box width="100%" gap="20px" justify="center">
                {decline && (
                    <ButtonV2
                        variant={decline.variant}
                        inverted={decline.inverted}
                        onClick={decline.onClick}
                        width="50%"
                    >
                        {decline.label}
                    </ButtonV2>
                )}

                <ButtonV2
                    variant={confirm.variant}
                    inverted={confirm.inverted}
                    width={decline && '50%'}
                    onClick={confirm.onClick}
                >
                    {confirm.label}
                </ButtonV2>
            </Box>
        </ConfirmModalElement>
    </Mask>
)
